<template>
  <div class="guide-card">
    <div class="d-flex align-items-center gap-2">
      <i class="guide-card__icon icon-outline_book"></i>
      <span class="guide-card__title">{{ $t('master.multiImei.import.guide') }}</span>
    </div>

    <hr />

    <div class="guide-card__list">
      <ol>
        <li>
          <p class="title">{{ $t('master.multiImei.import.downloadTemplate') }}</p>
          <p class="description">{{ $t('master.multiImei.import.downloadDesc') }}</p>
          <McButton
            :text="$t('master.multiImei.import.downloadTemplate')"
            icon="icon-outline_download"
            size="sm"
            @click="handleDownloadTemplate"
          />
        </li>
        <li>
          <p class="title">{{ $t('master.multiImei.import.copyData') }}</p>
          <p class="description">
            {{ $t('master.multiImei.import.copyDesc2') }}
          </p>
        </li>
        <li>
          <p class="title">{{ $t('master.multiImei.import.upload') }}</p>
          <p class="description">
            {{ $t('master.multiImei.import.uploadDesc3') }}
          </p>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
export default {
  components: {
    McButton,
  },
  methods: {
    handleDownloadTemplate() {
      window.open(`${process.env.VUE_APP_API_SMS_URL}/vehicle/hierarchy/import/template`, '_self')
    },
  },
}
</script>

<style lang="scss" scoped>
.guide-card {
  padding: 20px;
  padding-top: 15px;
  border-radius: 4px;
  background-color: $mep-secondary-100;
  width: 100%;
  height: fit-content;
  line-height: 20px;

  ol {
    margin: 0;
    padding: 0 20px;

    li {
      color: $mep-color-text;
      margin-top: 15px;
    }

    p {
      margin: 1px 0;
      color: $mep-color-text;
    }
  }

  &__icon:before {
    font-size: 24px;
    color: $mep-color-text-400;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: $mep-color-text;
  }

  &__list {
    .title {
      font-weight: 600;
    }

    .description {
      color: $mep-color-text-300;

      strong {
        font-weight: 700;
      }
    }
  }
}
</style>
